import { Component } from '@angular/core';
import { SharedMessageService } from 'baseline-lib';
import { SharedService } from 'baseline-lib';
import { FastBetService } from 'baseline-lib';
import { Event } from 'baseline-lib';
import { CustomToast } from '../../shared/services/custom-toast';
import { LoadingController, NavParams, NavController} from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { FastCodesPage } from '../../sports/fast-codes/fast-codes';
import { TranslateService } from '@ngx-translate/core';


/**
 * Generated class for the FastBetComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'fast-bet',
  templateUrl: 'fast-bet.html'
})
export class FastBetComponent {
  eventNo: any;
  code : string;
  _event : Event;
  eventSub : any;
  toggleList : boolean = false;
  fastCodes : Event ;
  win1 : any;

  constructor(
    private _sharedMessageService : SharedMessageService,
    public navCtrl: NavController,
    public toast: CustomToast,
    public translate : TranslateService,
    public modalCtrl : ModalController,
    public loadingCtrl: LoadingController,
    private _sharedService : SharedService,
    private _fastBetService : FastBetService) {
   }

   ngOnInit() {
    this.reset();
  }

  reset()
  {
    this.eventNo = null;
    this.code = '';
    this._event = undefined;
    this.toggleList = false;
  }
 

  

    // load all codes for placing bets
  popupBetCodes() {
    const loader = this.loadingCtrl.create({
      content: "Please Wait",
    });
      loader.present();
    this.eventSub = this._sharedMessageService.getFastBetCodes().subscribe(
    data =>
    {
      if(data && data.mli)
      {
        // let fastcodeModal = this.modalCtrl.create(FastCodesPage, {dataz:data});
        // fastcodeModal.present();   
        loader.dismiss();
        this.navCtrl.push(FastCodesPage, {dataz:data});
       
    }
    else{
     loader.dismiss();
    } 

    });

   return false;
  }

     // to clear event data on text field focus
  clearEventData()
  {
    this.reset();
  }

  // to get event data based on event code
  getEventData()
  {
   if(this.eventNo)
    {
      this._sharedService.showLoader();
      this._event = undefined;
      let gtid =this._sharedService.selectedGameType.gtid;
     
      this.eventSub = this._sharedMessageService.getFastBetDataByEvent(gtid ,this.eventNo).subscribe(
          data =>
          {
            if(data.eli && data.eli.length > 0)
            {
              this._event = new Event();
              this._event.constructEvent(data.eli[0],this._sharedService.selectedGameType.gtid);
              this.filterEvent();              
            }
            this._sharedService.hideLoader();
            if (data.msg) {
              this.toast.showError(data.msg);
            }
          },
          error =>
          {
            window.scroll(0,0);
            this._sharedService.hideLoader();
            if (error.msg) {
              this.toast.showError(error.msg);
            }
            else {
              this.translate.get('Server Error..').subscribe(
                value => 
                {
                  this.toast.showError(value);
                });
            }
          }
        );
    }
  }

    // to filter events for market Selections & codes present
    filterEvent()
    {
      // filter selections having unique codes
        this._event.mli.forEach(_market => {
          if(_market.sli && _market.sli.length >0)
          {
            _market.sli = _market.sli.filter(_selF => _selF.ucd !=undefined );
          }
        });
  
        //filter markets having selections
        this._event.mli =this._event.mli.filter(_market =>  _market.sli && _market.sli.length > 0);
    }
  
      // add selection to text box on click of selection in dropdown
  addSelection(_sel)
  {
    this.code = '';
    _sel.selected = !_sel.selected;
  
    this._event.mli.forEach(_market => {
    _market.sli.filter(_selF => _selF.selected==true ).forEach(_sel =>
        {
          if(this.code!='')
          this.code +='+';
      
          this.code += _sel.ucd ;
        })
    });
  }

    // filter codes selected on input change in code text field
 filterSelections(event)
 {
  if(!this.code.endsWith('+'))
  {  
    if(this.code.endsWith('+'))
      this.code = this.code.substr(0, this.code.lastIndexOf('+'));

    let splitCodes: string[] = this.code.split('+');
    let tmpCode ='';
    if(splitCodes.length >0 && this._event && this._event.mli && this._event.mli.length >0)
    {
      this._event.mli.forEach(_market => {
        _market.sli.forEach(_sel =>
          {
            _sel.selected = false;
            splitCodes.forEach(_code => {

              if(_code == _sel.ucd)
              { 
                _sel.selected = true;
              }

            });
          });
      });
    }
  }
   if (event.key === "Enter") { 
     this.loadFastBet();
   }
 }

 loadFastBet()
 {
  const loader = this.loadingCtrl.create({
    content: "Please Wait",
  });
   
   if(this.validateData())
   {
    loader.present();
     this.toggleList = false;
     let gtid =this._sharedService.selectedGameType.gtid;
     let re = /\+/gi;
     let codePipeSeparated = this.code.replace(re,',');
     this.eventSub = this._sharedMessageService.getFastBetDataByEventAndCode(gtid ,this.eventNo, codePipeSeparated).subscribe(
         data =>
         {
           if(data.eli && data.eli.length > 0)
           {
             this._event = new Event();
             if(data.eli[0].mli && data.eli[0].mli > 0)
             {
               this._event.constructEvent(data.eli[0],this._sharedService.selectedGameType.gtid);
               this._fastBetService.addToBetSlip(this._event , this._sharedService.selectedGameType.gtid);
             }
             else
              data.msg ='No Data Found for Code';
             this.reset();
           }
           loader.dismiss();
           if (data.msg) {

            this.translate.get(data.msg).subscribe(
              value => 
              {
                this.toast.showError(value);
              });
           }
         },
         error =>
         {
          loader.dismiss();
           if (error.msg) {
            this.toast.showError(error.msg);
           }
           else {
            this.translate.get('Server Error..').subscribe(
              value => 
              {
                this.toast.showError(value);
              });
           }
         }
       );
   }
 }

 // to validate input event & code
 validateData() : boolean
 {
   if (!this.eventNo || this.eventNo == null) {
    this.translate.get('Please Enter Event No').subscribe(
      value => 
      {
        this.toast.showError(value);
      });
     return false;
   } else if (!this.code || this.code == null) {
    this.translate.get('Please Select Code').subscribe(
      value => 
      {
        this.toast.showError(value);
      });
     return false;
   }else{
    return true;
   }
 }

 
 handleEventNoKeyUp() { 
  if (this.eventNo != null && this.eventNo.toString().length == 5) { 

    this.getEventData();
    document.getElementById("code").focus();
  }
}
ngOnDestroy()
  {
    if(this.eventSub)
      this.eventSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/fast-bet/fast-bet.ts